(() => {
  const root = window.Shopify?.routes?.root || '/';
  const request = async (path, body) => {
    const response = await fetch(root + path, body ? {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)} : {cache:'no-store'});
    const result = await response.json();
    if (!response.ok || result.errors) throw new Error(result.description || result.message || result.errors || 'Cart request failed');
    return result;
  };
  const properties = item => JSON.stringify(Object.entries(item.properties || {}).sort(([a],[b]) => a.localeCompare(b)));
  const plan = item => item.selling_plan_allocation?.selling_plan?.id || null;
  const matches = (item, source, id) => String(item.variant_id) === String(id) && properties(item) === properties(source) && plan(item) === plan(source);
  async function replaceLine(key, variantId, api = request) {
    const before = await api('cart.js');
    const source = before.items.find(item => item.key === key);
    if (!source) { const error = new Error('stale'); error.reviewRequired = true; throw error; }
    if (String(source.variant_id) === String(variantId)) return;
    if (source.selling_plan_allocation) throw new Error('unsupported');
    const oldTarget = before.items.find(item => matches(item, source, variantId));
    const priorQuantity = oldTarget?.quantity || 0;
    const expectedQuantity = priorQuantity + source.quantity;
    try {
      await api('cart/add.js', {items:[{id:Number(variantId),quantity:source.quantity,properties:source.properties || {}}]});
      const added = await api('cart.js');
      const replacement = added.items.find(item => matches(item, source, variantId));
      const original = added.items.find(item => matches(item, source, source.variant_id));
      if (!replacement || replacement.quantity !== expectedQuantity || !original || original.quantity !== source.quantity) throw new Error('changed');
      await api('cart/change.js', {id:original.key,quantity:0});
      const final = await api('cart.js');
      if (final.items.some(item => matches(item, source, source.variant_id)) || final.items.find(item => matches(item, source, variantId))?.quantity !== expectedQuantity) throw new Error('changed');
    } catch (error) {
      try {
        const current = await api('cart.js');
        const original = current.items.find(item => matches(item, source, source.variant_id));
        const replacement = current.items.find(item => matches(item, source, variantId));
        if (!original && replacement?.quantity === expectedQuantity) return;
        if (original?.quantity !== source.quantity) throw new Error('uncertain');
        const currentQuantity = replacement?.quantity || 0;
        if (currentQuantity !== priorQuantity) {
          if (currentQuantity < priorQuantity || currentQuantity > expectedQuantity) throw new Error('uncertain');
          await api('cart/change.js', {id:replacement.key,quantity:priorQuantity});
        }
        const restored = await api('cart.js');
        if (restored.items.find(item => matches(item, source, source.variant_id))?.quantity !== source.quantity || (restored.items.find(item => matches(item, source, variantId))?.quantity || 0) !== priorQuantity) throw new Error('uncertain');
      } catch (recoveryError) {
        const uncertain = new Error('uncertain');
        uncertain.reviewRequired = true;
        throw uncertain;
      }
      throw error;
    }
  }
  window.EMCartEditTransaction = replaceLine;
  let busy = false;
  let reviewRequired = false;
  document.addEventListener('click', async event => {
    const target = event.target.closest('button,a,summary');
    if (!target) return;
    if ((busy || reviewRequired) && !target.matches('[data-em-review]')) {
      if (target.closest('#Cart, #Cart-Drawer, product-form')) {event.preventDefault();event.stopImmediatePropagation();}
      return;
    }
    const editor = target.closest('.em-cart-edit');
    if (!editor) return;
    if (target.matches('[data-em-cancel]')) {editor.open = false;return;}
    if (!target.matches('[data-em-save]')) return;
    event.preventDefault();
    if (document.querySelector('.cart-disabled,.product-cart-item.loading') || document.getElementById('Cart')?.emCartPending || document.getElementById('Cart-Drawer')?.emCartPending) return;
    const select = editor.querySelector('select');
    if (!select.value || select.selectedOptions[0].disabled) return;
    busy = true;
    const notice = editor.querySelector('[data-em-edit-error]');
    notice.hidden = true;
    target.disabled = true;
    editor.setAttribute('aria-busy','true');
    document.querySelectorAll('#Cart form, #Cart-Drawer form').forEach(form => form.setAttribute('aria-busy','true'));
    try {
      await replaceLine(editor.dataset.key, select.value);
      window.location.assign(root + 'cart');
    } catch (error) {
      reviewRequired = !!error.reviewRequired;
      notice.textContent = reviewRequired ? editor.dataset.review : editor.dataset.error;
      notice.hidden = false;
      editor.querySelector('[data-em-review]').hidden = !reviewRequired;
      if (!reviewRequired) target.disabled = false;
    } finally {
      busy = false;
      editor.removeAttribute('aria-busy');
      document.querySelectorAll('#Cart form, #Cart-Drawer form').forEach(form => form.removeAttribute('aria-busy'));
    }
  }, true);
  document.addEventListener('change', event => {
    if ((busy || reviewRequired) && event.target.closest('#Cart, #Cart-Drawer, product-form')) {event.preventDefault();event.stopImmediatePropagation();}
  }, true);
  document.addEventListener('submit', event => {
    if ((busy || reviewRequired) && event.target.closest('#Cart, #Cart-Drawer, product-form')) {event.preventDefault();event.stopImmediatePropagation();}
  }, true);
})();
